<template>
    <div class="indexCont">
         <div class="mainCont"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading">
            <div class="search">
                <!-- <span>请选择分类：</span> -->
                <div class="search_left">
                    <el-radio-group v-model="radio" @input="changeRadio">
                        <el-radio :label="false">未学习</el-radio>
                        <el-radio :label="true">已学习</el-radio>
                    </el-radio-group>
                </div>
                <div class="search_right">
                    <el-autocomplete
                    class="inline-input"
                    v-model="state"
                    :fetch-suggestions="querySearch"
                    placeholder="请选择分类"
                    @select="handleSelect"
                    clearable
                    @clear="demo()"
                    ></el-autocomplete>
                    <el-input class="inputName" v-model="teacherName" placeholder="请输入讲师名" clearable></el-input>
                    <el-input class="inputName" v-model="searchName" placeholder="请输入关键字" clearable></el-input>
                    <el-button type="primary" size="medium" class="searchName" @click="categoryType(selectcategoryId)">查询</el-button>
                </div>
            </div>
            <div class="mobileSearch">
                <div class="classify_one">
                    <el-radio-group v-model="radio" @input="changeRadio">
                        <el-radio :label="false">未学习</el-radio>
                        <el-radio :label="true">已学习</el-radio>
                    </el-radio-group>
                </div>
                <div class="classify">
                    <el-autocomplete
                    class="inline-input"
                    v-model="state"
                    :fetch-suggestions="querySearch"
                    placeholder="请选择分类"
                    @select="handleSelect"
                    clearable
                    @clear="demo()"
                    ></el-autocomplete>
                    <el-button type="primary" size="medium" class="searchName" @click="categoryType(selectcategoryId)">查询</el-button>
                </div>
                <div class="classify2">
                    <el-input class="inputName" v-model="teacherName" placeholder="请输入讲师名" clearable></el-input>
                    <el-input class="inputName" v-model="searchName" placeholder="请输入关键字" clearable></el-input>
                </div>
            </div>
            <template v-if="!isShow">
                <div class="trainCont special" v-for="(item,index) in resourceList" :key="index">
                    <div class="t_head" v-if="item.category ? true : false">
                        <div class="t_txt">
                            <div>{{item.category.name}}</div>
                        </div>
                    </div>
                    <div v-for="(nItem,nIndex) in item.allCourseVo" :key="nIndex">
                        <div class="trainCont" v-if="nItem.courseList.length">
                            <div class="relate">
                                <div>{{nItem.category.name}}</div>
                                <div class="down" v-show="nItem.certStatus"  @click="downLoadCert(nItem.staffResourceCertVo)">证书下载</div>
                            </div>
                            <div class="trainItem" v-for="(item2,index2) in nItem.courseList" :key=index2 @click="goPage('./trainDetail?id=' + item2.courseId + '&coursename=' + item2.courseName)">
                                <div class="t_cont">
                                    <img :src="item2.thumbnailUrl ? $config.baseApi + item2.thumbnailUrl  : $config.baseApi + item2.picUri" alt="">
                                    <p class="resourceName">{{item2.courseName}}</p>
                                    <p>主讲人：{{item2.teacherName ?item2.teacherName : "暂无"}}</p>
                                    <!-- <p class="lock_p">学习状态：<span class="studyStatus" :id="item2.learnCount > 0 ? 'active' : '' ">{{item2.learnCount > 0 ? '已学习' : '未学习'}}</span> 
                                    </p> -->
                                    <!-- <img v-if="item2.locked == 1 ? true : false" class="lock" src="../../../assets/images/common/lock3.png" alt=""> -->
                                    <p>学习进度：<el-progress :percentage="parseFloat(item2.process)" :color="customColorMethod" :stroke-width="7" ></el-progress></p>
                                </div>
                                <div class="start">开始学习</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- 证书 -->
            <el-dialog
                :visible.sync="DialogVisibleCert"
                :width="certDialogWidth"
                :close-on-press-escape="false"
                center
                class="comTrain">
                <div class="certPic">
                    <img src="../../../assets/images/common/certPic.jpg" alt="" v-if="isShowCetrtPic">
                    <img :src="$config.baseApi + certPic" alt="" v-else>
                    <!-- <div class="cert_txt">
                        <div class="username">{{username}}</div>
                        <div class="certCode">编号No：{{certCode}}</div>
                        <div class="time">日期Date：{{certTime}}</div>
                    </div> -->
                </div>
            </el-dialog>
        </div>
        <!-- 移动端 -->
        <div class="mobileTest">
            <MobileComNav title="我的培训" url="./index"></MobileComNav>
        </div>
        <div class="comTxt" v-show="isShow">暂无数据</div>
    </div>
</template>

<script>
    import MobileComNav from "../../../components/mobileHead";
    export default {
        data(){
            return {
                classify: "",
                selectCont: [],
                state: '',
                loading: true,
                resourceList: "",
                relatedResource:"",//相关培训
                DialogVisibleCert:false,
                certDialogWidth:"5rem",
                isShowCetrtPic:true,
                username:"",
                certCode:"",
                certTime:"",
                certPic:"",
                isShow:false,
                percentage: "", //进度条百分比
                teacherName:"",
                searchName:"",
                selectcategoryId:"",
                radio:false//1为未学习，2为已学习
            }
        },
        mounted(){
            document.title=this.$route.meta.title;
        },
        components: {
            MobileComNav
        },
        methods:{
            goPage(url){
                this.$router.push(url)
            },
            // 按类获取资源（新）
            categoryType(categoryId){
                this.isShow = false
                this.$ajax({
                    url:this.$config.baseApi + "/account/wx/resource/list",
                    method:'post',
                    data:JSON.stringify({
                        categoryId:categoryId,
                        searchName:this.searchName,
                        teacherName:this.teacherName,
                        completeFlag:this.radio
                        // current:1,
                        // pageSize:10
                    })
                }).then(res=>{
                    if(res.code == 1){
                        this.loading = false;
                        // 不反data
                        if(res.data == undefined){
                            this.isShow = true;
                        }else{
                            if(res.data.length == 0 ){
                                this.isShow = true;
                            }
                            this.resourceList = res.data;
                            // let arr = []
                            // for(let i in this.resourceList){
                            //     if(this.resourceList[i].resourceListVo){
                            //             arr.push(this.resourceList[i])
                            //     }
                            // }
                            // if(arr.length == 0){
                            //     this.isShow = true;
                            // }
                        }
                        
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 拿去分类
            categoryType2(){
                this.$ajax({
                    url:this.$config.baseApi + "/account/wx/resource/list",
                    method:'post',
                    data:JSON.stringify({
                        categoryId:""
                    })
                }).then(res=>{
                    if(res.code == 1 && res.data != undefined){
                        this.resourceList = res.data;
                        for(let i in this.resourceList){
                            // 判断是否有资源
                            if(this.resourceList[i].category){
                                this.selectCont.push(this.resourceList[i].category)
                            }
                        }
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            downLoadCert(certVo){
                this.DialogVisibleCert=true,
                this.username = certVo.username;
                this.certCode = certVo.certCode;
                this.certTime = certVo.createTime.slice(0,10);
                let certPic = certVo.certPic;
                if(certPic){
                    this.certPic = certPic;
                    this.isShowCetrtPic = false;
                }
            },
            // 搜索框
            querySearch(queryString, cb) {
                for(let i in this.selectCont){
                    this.selectCont[i].value = this.selectCont[i].name
                }
                cb(this.selectCont)
            },
            handleSelect(item) {
                // console.log(item);
                this.selectcategoryId = item.id
                this.searchName = "";
                this.teacherName = ""
                this.categoryType(item.id);
            },
            demo(){
                this.selectcategoryId = ""
                this.categoryType();
            },
            customColorMethod(percentage) {
                if (percentage < 30) {
                    return '#f56c6c';
                } else if (percentage < 70) {
                    return '#e6a23c';
                } else {
                    return '#67c23a';
                }
            },
            changeRadio() {
                this.categoryType()
            }
        },
        created(){
            // this.categoryType2()
            this.categoryType()
            if(this.$IsPc()){
                this.certDialogWidth = "6rem"
            };
        }
    }
</script>

<style scoped>
    @import "../../../assets/css/home/home.css";
    .mainCont {
        background: #fff;
        padding:0;
        /* margin-bottom: 0.2rem; */
        min-height: 2rem;
        padding-bottom: 0.3rem;
    }
    .t_head .t_txt{
        display: flex;
        justify-content: space-between;
        position: relative;
        font-size:0.2rem;
    }
    .down{
        font-size: 0.14rem;
        cursor: pointer;
        box-sizing: border-box; 
        height: 0.3rem;
        line-height: 0.3rem;
        background:#2ca2db;
        color:#fff;
        padding:0rem 0.1rem;
        border-radius:0.2rem ;
        margin-right:0.2rem;
        }
    .trainCenter{
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        margin-bottom:0.3rem;
    }
    .relate{
        font-size: 0.18rem;
        margin: 0.2rem 0 0 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .trainItem{
        cursor: pointer;
    }
    .mainCenter{
        box-sizing: border-box;
    }
    .comBtn{
        display: inline-block;
        padding: 0.12rem 0;
        margin-left: 0.2rem;
    }
    .search{
        padding-left:0.26rem;
        padding-top:0.3rem;
        font-size:0.16rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* justify-content: flex-end; */
    }
    .search .el-autocomplete.inline-input {
        width: 30%;
    }
    .search .search_left {
        display: flex;
    }
    .search .search_right {
        display: flex;
    }
    .t_head{
        margin-top:0.3rem;
        font-size: 0.18rem;
        color:#fff;
        background: linear-gradient(top left, #3780d0, #2ca2db);/*渐变从左上角到右下角*/
        background: -ms-linear-gradient(top left, #3780d0, #2ca2db);
        background: -webkit-linear-gradient(top left, #3780d0, #2ca2db);
        background: -moz-linear-gradient(top left, #3780d0, #2ca2db);
        height: 0.36rem;
        /* border-radius:5px; */
        line-height: 0.36rem;
        padding:0 0.2rem ;
    }
    .page {
        text-align: center;
    }
    .comTxt{
        min-height: 4rem;
        width:90%;
        background-color: #fff;
        margin:0 auto;
    }
    /* 移动 */
    .mobileTest {
        display: none;
    }
    .switchTest{
        height: 0.8rem;
        display: flex;
        background: #fff;
        justify-content: space-around;
        align-items: center;
        padding:0 1rem;
        font-size:0.3rem;
        display: none;
    }
    .switchTest .active{
        height: 100%;
        border-bottom: 2px solid rgba(56, 124, 205, 1);
        box-sizing: border-box;
        line-height: 0.8rem;
        color:rgba(56, 124, 205, 1);
    }
    .line{
        height: 2px;
        width: 100%;
        border-bottom: 2px dashed #ccc;
        margin-top:0.1rem;
    }
    .trainCont{
        padding:0;
    }
    .inputName.el-input{
        width:30%;
        margin-left:0.2rem;
    }
    .el-button.searchName.el-button--primary.el-button--medium{
        margin: 0 0.2rem;
    }
    .mobileSearch{
        display:none;
    }
    @media screen and (max-width: 768px){
         .mobileSearch{
            display:block;
            /* padding-top:0.2rem; */
        }
        .mainCont .search{
            display: none;
        }
        .mobileSearch .classify{
            margin:0rem 0 0 0.2rem;
        }
        .mobileSearch .classify_one{
            height: 1rem;
            margin:0rem 0 0 0.2rem;
            display: flex;
            align-items: center;
        }
        .mobileSearch .classify2 .el-button{
            display: inline-block;
        }
        .mainCont{
            box-sizing: border-box;
            margin-top:0.9rem; 
            min-height: 1rem;
        }
        .trainCenter{
            padding:0 0.1rem
        }
        .switchTest{
            display: block;
            display: flex;
            margin-top:1.2rem;
        }
        .mobileTest {
            display: block;
            margin-top:0.2rem;
        }
        .comTxt{
            background-color: #f5f5f9;
        }
        .line{
            margin:0.2rem 0;
        }
        .t_head{
            padding:0 0.26rem 0;
            font-size: 0.36rem;
            height: 0.72rem;
            line-height: 0.72rem;
        }
        .relate{
            font-size: 0.28rem;
            margin-bottom: 0.2rem;
        }
        .t_head .t_txt{
            font-size: 0.32rem;
            position: relative;
        }
        .down{
            height: 0.5rem;
            line-height: 0.5rem;
            background:#417ccb;
            color:#fff;
            font-size: 0.24rem;
            padding:0rem 0.2rem;
            border-radius:0.3rem ;
            margin-right:0.2rem;
        }
        .search{
            padding-left:0.26rem;
            padding-top:0.3rem;
            font-size:0.32rem;
        }
        .search .el-autocomplete.inline-input {
            width: 60%;
        }
        .inputName.el-input{
            width:46%;
            margin-left:0.2rem;
            margin-top:0.2rem;
        }
    }
</style>
